var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "31px",
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buscar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.0_Busca",
    transform: "translate(-655.000000, -413.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(650.000000, 408.000050)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 C20,12.2592439 19.2507926,14.3435011 17.9872757,16.0178738 L31.0710678,29.101829 C31.3249086,29.3556698 31.3249086,29.767227 31.0710678,30.0210678 C30.817227,30.2749086 30.4056698,30.2749086 30.151829,30.0210678 L17.1357812,17.0057604 C15.321261,18.8537445 12.7944916,20 10,20 C4.4771525,20 6.76353751e-16,15.5228475 0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z M10,1.3 C5.19512268,1.3 1.3,5.19512268 1.3,10 C1.3,14.8048773 5.19512268,18.7 10,18.7 C14.8048773,18.7 18.7,14.8048773 18.7,10 C18.7,5.19512268 14.8048773,1.3 10,1.3 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.631830dbd87eee2277477ac1b057256f.svg";
export { ForwardRef as ReactComponent };